import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, Modal, Button, Form } from "react-bootstrap";
import Color from "../../assets/color";

// Components
import Icon from "../Icon";
import color from "../../assets/color";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";
import Geocode from "react-geocode";

import { google_api_key } from "../../config";

class Location extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  componentDidMount() {
    this.setState({
      showModal: true,
    });
  }

  componentDidUpdate(prevProps, prevState) {}
  toggle = () => {
    this.setState({
      showModal: !this.state.showModal,
    });
  };
  _renderCloseIcon = () => {
    return (
      <div className="btn-close" onClick={this.toggle}>
        <Icon type="custom" name="closecircle" color={color.black} size={30} />
      </div>
    );
  };

  render() {
    const { showModal } = this.state;
    return (
      <Modal
        size="lg"
        show={showModal}
        onHide={this.toggle}
        aria-labelledby="example-modal-sizes-title-lg"
        centered={true}
        backdrop="static"
        className="modal-home-location"
      >
        <div className="inner-container grey position-relative d-flex flex-column">
          {this._renderCloseIcon()}

          <img
            src={require("../../assets/img/home_banner/lolol_temp_closed.jpeg")}
            alt=""
          />
        </div>
      </Modal>
    );
  }
}

Location.propTypes = {
  isFirstLoad: PropTypes.bool.isRequired,
  storeLocation: PropTypes.object.isRequired,
  locationModalVisible: PropTypes.bool.isRequired,
  showModalLocation: PropTypes.func,
  hideModalLocation: PropTypes.func,
  onGetListLocation: PropTypes.func.isRequired,
  locationList: PropTypes.array.isRequired,
  onSubmitLocation: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isFirstLoad: state.IsFirstLoad.isFirstLoad,
    locationModalVisible: state.Location.locationModalVisible,
    storeLocation: state.Location.storeLocation,
    locationList: state.Location.locationList,
    isLoading: state.Location.isLoading,
    device_token: state.Auth.device_token,
    isLoggedIn: state.Auth.isLoggedIn,
    auth: state.Auth,
    isDeviceRegistered: state.Auth.isDeviceRegistered,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showModalLocation: () => dispatch(actions.showModalLocation()),
    hideModalLocation: () => dispatch(actions.hideModalLocation()),
    onGetListLocation: () => dispatch(actions.getLocationList()),
    onSubmitLocation: (params) => dispatch(actions.submitLocation(params)),
    showModalAlertWalletPin: () =>
      dispatch(actions.showModalAlertSetWalletPin()),
    // updateIsFirstLoad: () => dispatch(actions.updateIsFirstLoad())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Location);
